module.exports = __webpack_public_path__ + "04_glasses_black.5222fa5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer4/04_glasses_black.png
// module id = l59K
// module chunks = 0